import { Component } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {
  Platform,
  AlertController
} from '@ionic/angular';
// import {
//   Network
// } from '@ionic-native/network/ngx'
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import {
  DOWNLOAD_URL
} from '../environments/environment';
import {
  HvserviceService
} from '../app/api/hvservice.service';
import { NetworkService } from '../app/api/network.service';
import { debounceTime } from 'rxjs/operators';
import { Storage } from '@ionic/storage';
import { Router, RouterEvent } from '@angular/router';
import { IonicToastService } from '../app/api/ionic-toast.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})

export class AppComponent {

  activePath = '';
  pages: Array<{ title: string, url: string, icon: string }>;

  appPages = [
    {
      title: 'Home',
      url: '/welcome',
      icon: 'home'
    },
    {
      title: 'My Profile',
      url: '/myprofile',
      icon: 'people'
    },
    {
      title: 'Change Password',
      url: '/changepassword/2',
      icon: 'speedometer'
    },
    {
      title: 'Contact Us',
      url: '/contactus',
      icon: 'headset'
    },
    {
      title: 'Logout',
      // url: '**',
      icon: 'log-out'
    }
  ]

  // set up hardware back button event.
  appVersion: any;
  currentVersion: any;
  VersionNumber: any;
  deviceplatform: any;
  _isApp: boolean = false;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public alertController: AlertController,
    private hvService: HvserviceService,
    private networkService: NetworkService,
    private storage: Storage,
    private router: Router,
    private ionicToastService: IonicToastService
  ) {

    this.router.events.subscribe((event: RouterEvent) => {
      this.activePath = event.url
    })
    this.networkSubscriber();


    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      AppVersion.getVersionNumber().then(value => {
        this.appVersion = value;
        this.VersionNumber = value;
        // alert('App version is : ' + value);
      }).catch(err => {
        // alert("Version Alert-> " + JSON.stringify(err));
      });
      if (this.platform.is('android')) {
        this.deviceplatform = 'android';
        this._isApp = true;
        // alert("running on Android device!");
      } else if (this.platform.is('ios') && this.platform.is('ipad')) {
        this.deviceplatform = 'iPad';
        this._isApp = true;
        //  alert("running in a browser on iPad!");
      } else if (this.platform.is('ios') && !this.platform.is('ipad')) {
        this.deviceplatform = 'iPhone';
        this._isApp = true;
        //  alert("running on iOS device!");
      } else {
        this.deviceplatform = 'webView';
        this._isApp = false;
        // console.log("running in a browser on webView");
      }
      this.checkVersion();


      ///push notifications using OneSignal
      //Remove this method to stop OneSignal Debugging 
      // window["plugins"].OneSignal.setLogLevel({ logLevel: 6, visualLevel: 0 });

      // var notificationOpenedCallback = function (jsonData) {
      //   console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
      // };

      // // Set your iOS Settings
      // var iosSettings = {};
      // iosSettings["kOSSettingsKeyAutoPrompt"] = false;
      // iosSettings["kOSSettingsKeyInAppLaunchURL"] = false;

      // window["plugins"].OneSignal
      //   .startInit("YOUR_ONESIGNAL_APP_ID")
      //   .handleNotificationOpened(notificationOpenedCallback)
      //   .iOSSettings(iosSettings)
      //   .inFocusDisplaying(window["plugins"].OneSignal.OSInFocusDisplayOption.Notification)
      //   .endInit();

      // // The promptForPushNotificationsWithUserResponse function will show the iOS push notification prompt. We recommend removing the following code and instead using an In-App Message to prompt for notification permission (See step 6)
      // window["plugins"].OneSignal.promptForPushNotificationsWithUserResponse(function (accepted) {
      //   console.log("User accepted notifications: " + accepted);
      // });
      ///push notifications using OneSignal
    });

    // this.platform.ready().then(() => {
    //   this.statusBar.styleDefault();
    //   this.splashScreen.hide();
    // });
  }

  networkSubscriber(): void {
    this.networkService
      .getNetworkStatus()
      .pipe(debounceTime(400))
      .subscribe((connected: boolean) => {
        // this.presentAlert(connected, 'isConnected = ');
        // set a key/value
        this.storage.set('isConnected', connected);
        this.storage.get('isConnected').then((val) => {
          // console.log('component: ', val);
        });
        this.handleNotConnected(connected);
      });
  }

  handleNotConnected(status) {
    if (status === true) {
      // console.log('You are now Online');
      // this.presentAlert('You are now Online', "Network Status");
    } else {
      // console.log('You are now Offline');
      // this.presentAlert('You are now Offline', "Network Status");
    }

  }


  async presentAlert(message, header) {
    const alert = await this.alertController.create({
      message: message,
      subHeader: header,
      buttons: ['Dismiss']
    });
    await alert.present();
  }


  async checkVersion() {
    var observer = this.hvService.getVersionEntity$()
      .subscribe(res => {
        this.currentVersion = res.CurrentVersion;
        if (parseFloat(this.currentVersion) > parseFloat(this.appVersion)) {
          this.presentConfirm();
        }
      },
        err => {
          // console.log(err);
        }
      );
  }

  logOutConfirm(p) {
    // console.log("p: " + JSON.stringify(p));
    if (p.title === "Logout") {
      this.ionicToastService.showAlertConfirm("logout...!", "Are you sure you want to log out?", 1);
    }
  }

  async presentConfirm() {
    const alert = await this.alertController.create({
      header: "Confirmation",
      message: "Please upgrade app to new version before you start registration",
      buttons: [
        {
          text: 'Update',
          handler: () => {
            if (this._isApp) {
              InAppBrowser.create(DOWNLOAD_URL, "_system", "location=yes,enableviewportscale=yes");
            } else {
              window.open(DOWNLOAD_URL, "_system", "location=yes");
            }
          }
        }, {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }
      ]
    });

    await alert.present();
  }


}
